// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1gNah","title":"ClientReferral_title__3huAC","itemText":"ClientReferral_itemText__Pyy9-"};